import localforage from 'localforage';

const filesDb = localforage.createInstance({
  name: 'round-offline',
  storeName: 'files'
});

export async function putOfflineFile({ blob, mime, filename, meta }) {
  const key = `file_${Date.now()}_${Math.random().toString(16).slice(2)}`;
  await filesDb.setItem(key, {
    blob,
    mime: mime || blob?.type,
    filename: filename || 'upload',
    meta: meta || null,
    ts: Date.now()
  });
  return key;
}

export async function getOfflineFile(key) {
  return await filesDb.getItem(key);
}

export async function removeOfflineFile(key) {
  await filesDb.removeItem(key);
}

export async function removeOfflineFilesForRound(roundId) {
  const keys = await filesDb.keys();
  for (const k of keys) {
    const v = await filesDb.getItem(k);
    if (v?.meta?.roundId === roundId) {
      await filesDb.removeItem(k);
    }
  }
}